<!-- #region HTML -->
<template>
  <!-- #region Main Container -->
  <div class="app">
    <!-- #region Alert Component -->
    <alert :SystemErrorAlert="isSystemError" @update:SystemErrorAlert="isSystemError = $event"></alert>
    <!-- #endregion -->

    <!-- #region Form Section -->
    <div class="main-container">

      <!-- #region Steps Section -->
      <div class="steps">
        <div class="right-box">
          <div class="sub-container">
            <!-- #region Title -->
            <div class="title">
              <label>パスワード再設定</label>
            </div>
            <!-- #endregion Title -->

            <!-- #region Step Box -->
            <div class="step-box text-left">
              <label class="step-title sp-hide">ステップ 1/2</label>
              <label class="step-description sp-hide">メールアドレスを入力してください。</label>
            </div>
            <!-- #endregion -->
          </div>
          <!-- #region Step Description Box -->
          <div class="step-description-box text-left">
            <label class="step-title">ステップ 1/2</label>
            <div class="step-description">メールアドレスを入力してください。</div>
          </div>
          <!-- #endregion -->
        </div>
      </div>
      <!-- #endregion -->

      <!-- #region Form Submission -->
      <form novalidate @submit.prevent="validateUser">
        <md-card class="form-container">

          <!-- #region Email Input -->
          <div class="md-form">
            <md-field :class="getValidationClass('email')">
              <md-input id="email" v-model="form.email" name="email" type="email" placeholder="メールアドレスID"
                :disabled="sending" @input="clearErrorFlag()" />
              <span v-if="!$v.form.email.required" class="md-error error">メールアドレスIDを入力してください。</span>
              <span v-else-if="!$v.form.email.email" class="md-error error">入力されたメールアドレスに誤りはございませんか？</span>
              <span v-else-if="isUserNotActive === true"
                class="md-error error alias-error">ユーザー登録が完了しておりません。ユーザー登録を完了してください。</span>
            </md-field>
          </div>
          <!-- #endregion -->

          <!-- #region Progress Bar -->
          <md-progress-bar v-if="sending" md-mode="indeterminate" />
          <!-- #endregion -->

          <!-- #region Submit Button and Instructions -->
          <div class="submit-container">
            <md-card-actions>
              <md-button type="submit" class="primary-button" :disabled="sending">認証コードをメールで受け取る</md-button>
            </md-card-actions>
            <md-card-content>
              <label>入力されたメールアドレスIDでユーザー登録がない場合、認証コードはメール送信されません。<br />
                認証コードが届かない場合は、メーラーの迷惑フォルダーをご確認ください。</label>
            </md-card-content>
          </div>
          <!-- #endregion -->

        </md-card>
      </form>
      <!-- #endregion -->

    </div>
    <!-- #endregion -->

  </div>
  <!-- #endregion -->
</template>

<!-- #endregion -->

<!-- #region JavaScript -->
<script>
// @ is an alias to /src
import { Auth } from 'aws-amplify'
import { validationMixin } from 'vuelidate'
import { required, email, maxLength } from 'vuelidate/lib/validators'
import Alert from '@/layout/Alerts.vue';

export default {
  name: 'ForgotPassword',
  mixins: [validationMixin],
  components: {
    "alert": Alert
  },
  data: () => ({
    form: {
      email: null,
    },
    userSaved: false,
    sending: false,
    message: '',
    isUserNotActive: false,
    isSystemError: false,
  }),
  created() { },
  validations: {
    form: {
      email: {
        required,
        maxLength: maxLength(256),
        email,
      },
    },
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        if (fieldName == 'email') {
          if (field.$anyError || this.isUserNotActive) {
            return { 'md-invalid': true };
          }
        }
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    clearForm() {
      this.$v.$reset()
    },
    clearErrorFlag() {
      this.isUserNotActive = false
      this.isSystemError = false
    },
    async saveUser() {
      this.clearErrorFlag()
      this.sending = true
      try {
        const result = await Auth.forgotPassword(this.form.email)
      } catch (error) {
        if (error.code != 'UserNotFoundException') {
          if (error.code === 'InvalidParameterException') {
            this.isUserNotActive = true
          } else {
            this.isSystemError = true
          }
          this.sending = false
          return
        }
      }
      this.$store.commit('setForgotPasswordEmail', this.form.email)
      this.userSaved = true
      this.sending = false
      this.clearForm()
      this.$router.push('/verify-forgot-password')
    },
    async validateUser() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.saveUser()
    },
  },
}
</script>
<!-- #endregion -->

<!-- #region CSS -->
<style lang="scss" scoped>
/* #region Base Styles */
.submit-container {
  margin: 0px;
  padding-top: 50px;
  padding-bottom: 50px;
  margin-bottom: 40px;
}

.md-card .md-card-actions {
  margin: 0 !important;
  padding-top: 0px !important;
  padding-bottom: 30px !important;
}

.md-card .md-card-content {
  padding-top: 0px;
  padding-bottom: 0px;
}
/* #endregion */

/* #region SP */

@media screen and (max-width:767px) {
  .submit-container {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .md-card .md-card-actions {
    padding-top: 0px !important;
    padding-bottom: 20px !important;
  }

  .md-card .md-card-content {
    padding-left: var(--card-horizontal-padding);
    padding-right: var(--card-horizontal-padding);
  }
}

/* #endregion */
</style>
<!-- #endregion -->
